<!-- ================研学体验馆-研学悟心营线下活动====================-->
<template>
    <div class="educational-offline-page">
        <home-head />
        <div class="educational-offline-body">
            <div class="educational-offline-inner">
                <div class="educational-offline-header">
                    <div class="educational-offline-title-box">
                        <div class="educational-offline-title">行·知行合一</div>
                        <div class="educational-offline-subtitle">自然研学实践、户外主题班会、生态体验活动</div>
                    </div>
                    <div class="educational-offline-actions">
                        <!-- <input class="search-input" type="text" placeholder="请输入关键词" v-model="searchKeyword" />
                        <div class="search-btn" @click="handleSearch">搜索</div> -->
                        <div class="back-btn" @click="goBack">
                            <span class="back-arrow">←</span>
                            <span>返回</span>
                        </div>
                    </div>
                </div>

                <div class="educational-offline-cards">
                    <div class="educational-offline-card cursor" v-for="(item, index) in categoryList" :key="index" @click="handleCategory(item)">
                        <div class="educational-offline-card-box">
                            <div class="educational-offline-card-main">
                                <div class="educational-offline-card-month">{{ item.itemMonth }}</div>
                                <div class="educational-offline-card-theme">{{ item.itemDesc }}</div>
                            </div>
                            <div class="educational-offline-card-desc"></div>
                            <div class="educational-offline-card-desc">&nbsp;</div>
                            <div class="educational-offline-card-desc">&nbsp;</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {listItem} from "@/api/admin/item"
import homeHead from "@/components/common/homeHead.vue";
export default {
    components: {homeHead},
    name: "educationalOffline",
    data() {
        return {
            searchKeyword: "",
            categoryList: [],
            queryItemForm:{
                itemType:'6',
                museumKey:'5',
            },
        }
    },
    computed: {},
    watch: {},
    created() {
        this.queryItemList();
    },
    mounted() {},
    methods: {
        /* ===============数据查询===================== */
        queryItemList(){
            listItem(this.queryItemForm).then(res => {
                if (res.data.code===1){
                    this.categoryList = res.data.data;
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        /* ===============跳转===================== */
        handleSearch(){
            this.$message.success("搜索：" + this.searchKeyword)
        },
        goBack(){
            this.$router.push("/museum/educational")
        },
        handleCategory(item){
            this.$router.push({
                path: "/museum/educational/offlinePage",
                query: { item: item.itemId },
            });
        }
    }
}
</script>

<style scoped>
.educational-offline-page{
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.educational-offline-body{
    flex: 1;
    min-height: 0;
    width: 100%;
    background-color: #fdfcf8;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 30px 0;
    box-sizing: border-box;
    overflow: hidden;
}
.educational-offline-inner{
    width: 100%;
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}
.educational-offline-header{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    flex-shrink: 0;
}
.educational-offline-title-box{
    display: flex;
    flex-direction: column;
}
.educational-offline-title{
    font-size: 20px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 2px;
    margin-bottom: 8px;
}
.educational-offline-subtitle{
    font-size: 14px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}
.educational-offline-actions{
    display: flex;
    align-items: center;
    gap: 12px;
}
.search-input{
    width: 180px;
    height: 32px;
    line-height: 32px;
    padding: 0 10px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    outline: none;
    font-size: 13px;
    font-family: sans-serif;
    box-sizing: border-box;
}
.search-input:focus{
    border-color: #b22222;
}
.search-btn{
    height: 32px;
    line-height: 32px;
    padding: 0 18px;
    border: 1px solid #b22222;
    border-radius: 4px;
    font-size: 13px;
    color: #b22222;
    background-color: #ffffff;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
}
.search-btn:hover{
    background-color: #b22222;
    color: #ffffff;
}
.back-btn{
    height: 32px;
    line-height: 32px;
    padding: 0 26px;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    font-family: sans-serif;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
}
.back-btn:hover{
    background-color: #9a1b1b;
}
.back-arrow{
    margin-right: 6px;
    font-size: 16px;
}
.educational-offline-cards{
    width: 100%;
    flex: 1;
    min-height: 0;
    margin-bottom: 40px;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: repeat(2, 1fr);
    gap: 20px;
    box-sizing: border-box;
}

.educational-offline-card{
    min-width: 0;
    min-height: 0;
    background-color: #ffffff;
    border: 1.5px solid #b22222;
    border-radius: 4px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 3px;
    cursor: pointer;
    transition: all 0.25s ease;
}
.educational-offline-card:hover{
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0,0,0,0.1);
}
.educational-offline-card-box{
    width: 100%;
    height: 100%;
    border: 1px solid #e99d42;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}

.educational-offline-card-main{
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
}
.educational-offline-card-month{
    font-size: 20px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    margin-bottom: 6px;
}
.educational-offline-card-theme{
    font-size: 18px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
}
.educational-offline-card-desc{
    font-size: 12px;
    color: #e99d42!important;
    font-family: sans-serif;
    text-align: center;
    line-height: 2.4;
}
@media (max-width: 1280px) {
    .educational-offline-inner { padding: 0 20px; }
    .educational-offline-cards { gap: 16px; margin-bottom: 30px; }
    .educational-offline-card { padding: 3px 3px; }
    .educational-offline-card-month { font-size: 18px; }
    .educational-offline-card-theme { font-size: 16px; }
    .educational-offline-card-desc { font-size: 11px; }
}
@media (max-width: 1024px) {
    .educational-offline-title { font-size: 16px; }
    .educational-offline-subtitle { font-size: 12px; }
    .search-input { width: 140px; }
    .back-btn { padding: 0 18px; font-size: 13px; }
    .educational-offline-cards { gap: 12px; margin-bottom: 20px; }
    .educational-offline-card { padding: 3px 3px; }
    .educational-offline-card-month { font-size: 14px; }
    .educational-offline-card-theme { font-size: 13px; }
    .educational-offline-card-desc { font-size: 10px; }
}
</style>
